import * as React from 'react'
import './stepper-college.scss'

export const StepperCollege = ({ activeStep, numberOfSteps }) => {
  const steps = Array.from({ length: numberOfSteps }, (n, index) => index + 1)

  return (
    <div className="f-stepper-college">
      {steps.map(step => {
        let isActive = step === activeStep

        return (
          <div
            key={step}
            className={`f-stepper-college__step ${
              isActive ? 'f-stepper-college__step--active' : ''
            }`}
          >
            <span>{step}</span>
          </div>
        )
      })}
    </div>
  )
}
